import Vue from 'vue';

import dataLayerPush from '../helpers/dataLayerPush';

export default function(el) {
  if (el === null) return false;
  const v = new Vue({
    el,
    methods: {
      callClickHandle(communitySlug) {
        dataLayerPush({
          event: 'call',
          ...(communitySlug !== null && {
            community: communitySlug,
          }),
          currency: 'AUD',
          value: 30,
        });
      },
    },
  });

  return v;
}
